import { useEffect } from 'react';

import HomeBarButton from '@core/dashboard/components/HomeBarButton';
import { useAssistant } from '@core/assistant/providers/Provider';
import { useGreetings } from '@core/assistant/providers/Greetings';
import { VirtualAssistantIcon } from './VirtualAssistantIcon';
import { useStyles } from './styles';
import { log } from '../providers/Debug';

const Button = ({ isLargeButton }: { isLargeButton?: boolean }) => {
  const { setOpen, isAIEnabledForEvent, startFlow, open, scripts } =
    useAssistant();
  const classes = useStyles(isLargeButton);
  const { playBackOnFirstTime } = useGreetings();

  useEffect(() => {
    log('scripts', scripts);
    if (!scripts?.length) {
      return;
    }

    if (isAIEnabledForEvent()) {
      setTimeout(() => {
        setOpen(true);
      }, 0);
      startFlow('landing');
      // playBackOnFirstTime();
    }
  }, [scripts]);

  return (
    <HomeBarButton
      sx={classes.homeBarButton}
      label={'Noa Assistant'}
      icon={<VirtualAssistantIcon isLargeButton={isLargeButton} />}
      handleClick={() => {
        setOpen((prevState) => !prevState);
      }}
    />
  );
};

export default Button;
